module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "personal-center-form__title repayment_h1"
  }, [_vm._v("Details of the repayment plan"), _c('span', {
    staticClass: "ask-time"
  }, [_vm._v("Application time　" + _vm._s(_vm.detail.financeRepayDate))])]), _vm._v(" "), _c('div', {
    staticClass: "repayment-top"
  }, [_c('dl', {
    staticClass: "text-center should-repaymen"
  }, [_c('dt', [_vm._v("Amount payable")]), _vm._v(" "), _c('dd', [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(_vm.detail.financeRepayBalanced, 2)))])]), _vm._v(" "), _c('ul', {
    staticClass: "repay-details"
  }, [_c('li', [_c('span', [_vm._v("Principal")]), _c('strong', [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(_vm.detail.financeRepayPrincipal, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Consulting fee")]), _c('strong', [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(_vm.detail.financeRepayFee, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Interest")]), _c('strong', [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(_vm.detail.financeRepayInterest, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Total amount of repayment")]), _c('strong', [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(_vm.detail.financeRepaySum, 2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "repayment-tips"
  }, [_vm._v("From " + _vm._s(_vm.detail.bankAccountInfo) + "Automatic deduction")]), _vm._v(" "), _c('repayment-list', {
    attrs: {
      "infoList": _vm.detail
    },
    on: {
      "getRepayList": _vm.getData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e3114f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RepaymentInfo.vue
// module id = 1989
// module chunks = 5